import { FormattedMessage } from "react-intl";

const CriticalIssueSupport = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="JiraServiceManagementPricingPageTeam24.features.criticalIssueSupport.content.body"
                    defaultMessage="24/7 support with faster response times for high-impact issues. <a>Learn more.</a>"
                    values={{
                        a: (chunks) => (
                            <a
                                data-event="clicked"
                                data-event-component="linkButton"
                                data-product-key="jira-service-management"
                                data-label-english="learn more"
                                href="https://confluence.atlassian.com/support/atlassian-support-offerings-193299636.html#AtlassianSupportOfferings"
                            >
                                {chunks}
                            </a>
                        )
                    }}
                />
            </p>
        </div>
    );
};

export default CriticalIssueSupport;
